<header>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
      <a class="navbar-brand" href="#">
        <img src="assets/images/default-logo.svg" alt="" />
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02"
        aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
        <ul class="navbar-nav ml-auto mr-auto mt-2 mt-lg-0">
          <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              routerLink="/dashboard">Dashboard</a>
          </li>
          <li class="nav-item" *rbacAllow="[true]">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              routerLink="/staff">USERS</a>
          </li>

          <li *rbacAllow="[true]" class="nav-item">
            <a [matMenuTriggerFor]="menu" class="nav-link" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">LEARNING MANAGEMENT <mat-icon>arrow_drop_down</mat-icon></a>

            <mat-menu #menu="matMenu" class="menu">
              <button mat-menu-item routerLink="/assignCourse">ASSIGN COURSE</button>
              <button mat-menu-item routerLink="/learningPath">LEARNING PATHS</button>
              <button mat-menu-item routerLink="/mentorship">MENTORSHIP</button>
              <button mat-menu-item routerLink="/staff/view-mentees" [hidden]="mentorId == null">MENTEES</button>
            </mat-menu>
          </li>

          <li class="nav-item" *rbacAllow="[true]">
            <a [matMenuTriggerFor]="courseMenu" class="nav-link" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">COURSE MANAGEMENT <mat-icon>arrow_drop_down</mat-icon></a>

            <mat-menu #courseMenu="matMenu" class="menu">
              <button mat-menu-item routerLink="/categories" *rbacAllow="[true]">MANAGE CATEGORIES</button>
              <button mat-menu-item routerLink="/courses">COURSES</button>
            </mat-menu>
          </li>

          <li class="nav-item" *rbacAllow="[true]">
            <a [matMenuTriggerFor]="settingMenu" class="nav-link" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">SETTINGS <mat-icon>arrow_drop_down</mat-icon></a>

            <mat-menu #settingMenu="matMenu" class="menu">
              <button mat-menu-item routerLink="/setting/profile">COMPANY PROFILE</button>
              <button mat-menu-item routerLink="/setting/structure">STRUCTURE SETUP</button>
            </mat-menu>
          </li>

          <li class="nav-item" *rbacAllow="[false]">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              routerLink="/courses">COURSES</a>
          </li>
          <li class="nav-item" *rbacAllow="[false]">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              routerLink="/learning">MY LEARNING</a>
          </li>
          <li class="nav-item" *rbacAllow="[false]">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              routerLink="/staff/view-mentees" [hidden]="!mentorId">MENTORSHIP</a>
          </li>
          <li class="nav-item" *rbacAllow="[false]">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              routerLink="/schedule">SCHEDULE</a>
          </li>
          <li class="nav-item" *rbacAllow="[false]">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/staff/staff-details', this.enterpriseUserId]">SETTINGS</a>
          </li>
        </ul>
        <ul class="navbar-nav drop-down mt-2 mt-lg-0">
          <li class="text-white nav-item font14 mt-3">
            Hi, {{ userDetails?.full_name }} <br />
            <span class="font12">{{
              userDetails?.admin ? 'Administrator' : 'Staff'
              }}</span>
          </li>
          <li class="nav-item dropdown mt-2">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <img src="{{
                  userDetails?.avatarUrl
                    ? userDetails?.avatarUrl
                    : 'assets/images/avatar.jpg'
                }}" alt="" />
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/staff/staff-details', this.enterpriseUserId]"
                *rbacAllow="[false]">Profile</a>
              <a class="dropdown-item" href="/setting/profile" *rbacAllow="[true]">Profile</a>
              <a class="dropdown-item" href="/setting/profile" *rbacAllow="[true]">Settings</a>
              <a class="dropdown-item" (click)="logOut()">Logout</a>
            </div>
          </li>
          <!-- <li class="nav-item with-img">
            <img
              src="{{
                userDetails?.avatarUrl
                  ? userDetails?.avatarUrl
                  : 'assets/images/avatar.jpg'
              }}"
              alt=""
            />
          </li> -->
          <li class="nav-item noti-icon mt-3 ml-2" drawer-trigger="notification">
            <img src="/assets/icons/noti-icon.svg" alt="" />
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
<app-notification></app-notification>